import { render, staticRenderFns } from "./SearchView.vue?vue&type=template&id=8ae4442a"
import script from "./SearchView.ts?vue&type=script&lang=ts&external"
export * from "./SearchView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports